import { render } from "./Watch.vue?vue&type=template&id=b9c6520c&ts=true"
import script from "./Watch.vue?vue&type=script&lang=ts"
export * from "./Watch.vue?vue&type=script&lang=ts"

import "./Watch.vue?vue&type=style&index=0&id=b9c6520c&lang=css"

import exportComponent from "/Users/rickvanwell/Work/Signals/webui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__